// extracted by mini-css-extract-plugin
export var statItem = "_eg-1";
export var statsRow = "_eg-0";